import { NgModule, ModuleWithProviders } from '@angular/core';
import { APP_INSIGHTS_CONFIG } from './tokens';
import { ApplicationInsightsService } from './application-insights.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    ApplicationInsightsService
  ]
})
export class AppInsightsModule {
  static forRoot(resolveFn: Function): ModuleWithProviders<AppInsightsModule> {
    return {
      ngModule: AppInsightsModule,
      providers: [
        {
          provide: APP_INSIGHTS_CONFIG, useFactory: resolveFn
        }
      ]
    };
  }

  constructor(private appInsights: ApplicationInsightsService) {
  }
}
